import React, { useState } from "react";

const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const jobStats = [
    { label: "Mon", views: 50, applied: 30 },
    { label: "Tue", views: 60, applied: 35 },
    { label: "Wed", views: 122, applied: 34 },
    { label: "Thu", views: 90, applied: 40 },
    { label: "Fri", views: 45, applied: 20 },
    { label: "Sat", views: 30, applied: 18 },
    { label: "Sun", views: 55, applied: 25 },
  ];

  return (
    <div className="flex min-h-screen bg-[#0e0e0e] text-white">
      {/* Sidebar (responsive) */}
      <aside
        className={`fixed z-20 md:static top-0 left-0 h-full md:h-auto bg-[#151515] flex flex-col justify-between p-5 w-60 transform transition-transform duration-300
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"}`}
      >
        <div>
          <h2 className="text-2xl font-bold text-center mb-8">JobX</h2>
          <ul className="space-y-2">
            {[
              "Dashboard",
              "Messages",
              "Company Profile",
              "All Applicants",
              "Job Listing",
              "My Schedule",
            ].map((item, i) => (
              <li
                key={i}
                className={`p-3 rounded-md cursor-pointer transition ${
                  i === 0
                    ? "bg-[#1ed760] text-black"
                    : "hover:bg-[#1ed760] hover:text-black"
                }`}
              >
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="text-gray-400 text-sm space-y-1 mt-6">
          <p>Settings</p>
          <p>Help Center</p>
        </div>
      </aside>

      {/* Overlay on mobile */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-10 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <main className="flex-1 p-4 sm:p-6 md:p-8 overflow-y-auto w-full md:ml-0">
        {/* Header */}
        <header className="flex justify-between items-center mb-6">
          <button
            className="md:hidden bg-[#1ed760] text-black px-3 py-2 rounded-md"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            ☰
          </button>
          <button className="bg-[#7b5cff] hover:bg-[#9b7dff] px-4 py-2 rounded-md transition">
            + Post a Job
          </button>
        </header>

        {/* Overview Section */}
        <section className="mt-4">
          <h2 className="text-xl sm:text-2xl font-bold">
            Good Morning, Nitish
          </h2>
          <p className="text-gray-400 mt-1 text-sm sm:text-base">
            Here is your job listing report from Oct 19 - Oct 25.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-6">
            <div className="bg-[#7b5cff] p-6 rounded-xl">
              <h1 className="text-4xl font-bold">76</h1>
              <p>New candidates to review</p>
            </div>
            <div className="bg-[#1ed760] text-black p-6 rounded-xl">
              <h1 className="text-4xl font-bold">3</h1>
              <p>Schedules for today</p>
            </div>
            <div className="bg-[#3aa0ff] p-6 rounded-xl">
              <h1 className="text-4xl font-bold">24</h1>
              <p>Messages received</p>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Custom Chart */}
          <div className="bg-[#1a1a1a] p-6 rounded-xl">
            <h3 className="text-lg font-semibold mb-4">Job Statistics</h3>
            <div className="flex items-end h-40 justify-between">
              {jobStats.map((d, i) => (
                <div key={i} className="flex flex-col items-center flex-1">
                  <div className="relative w-5 flex justify-center">
                    <div
                      className="bg-[#7b5cff] w-2 rounded-t"
                      style={{ height: `${d.views / 2}px` }}
                    ></div>
                    <div
                      className="bg-[#1ed760] w-2 rounded-t absolute bottom-0"
                      style={{ height: `${d.applied / 2}px`, opacity: 0.8 }}
                    ></div>
                  </div>
                  <p className="text-xs text-gray-400 mt-2">{d.label}</p>
                </div>
              ))}
            </div>
            <div className="flex justify-center mt-4 space-x-4 text-sm">
              <div className="flex items-center space-x-1">
                <span className="w-3 h-3 bg-[#7b5cff] inline-block rounded-full"></span>
                <span>Views</span>
              </div>
              <div className="flex items-center space-x-1">
                <span className="w-3 h-3 bg-[#1ed760] inline-block rounded-full"></span>
                <span>Applied</span>
              </div>
            </div>
          </div>

          {/* Job Open */}
          <div className="bg-[#1a1a1a] p-6 rounded-xl">
            <h3 className="text-lg font-semibold mb-4">Job Open</h3>
            <h1 className="text-4xl font-bold">12</h1>
            <p className="text-gray-400 mt-1">Jobs Opened</p>
          </div>

          {/* Applicants Summary */}
          <div className="bg-[#1a1a1a] p-6 rounded-xl">
            <h3 className="text-lg font-semibold mb-4">Applicants Summary</h3>
            <p className="text-gray-300 mb-3">67 Applicants</p>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center">
                <span className="w-3 h-3 bg-[#7b5cff] rounded-full mr-2"></span>
                Full Time: 45
              </li>
              <li className="flex items-center">
                <span className="w-3 h-3 bg-[#1ed760] rounded-full mr-2"></span>
                Part Time: 24
              </li>
              <li className="flex items-center">
                <span className="w-3 h-3 bg-[#ff9f43] rounded-full mr-2"></span>
                Internship: 32
              </li>
            </ul>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Dashboard;
